import {Button} from '@components/common/button/button'
import {Popup} from '@components/common/popup/popup'
import {TwCancelButton} from '@components/sticker/my-stickers/common/cancel-button/cancel-button'
import {noPropagate} from '@containers/hooks'
import {Sticker, stickerCtl} from '@extensions/sticker/sticker'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {useMultiActionsWithTasksStore} from '../multi-actions-with-tasks-store'

const stringCtl = stickerCtl.String
const sprintCtl = stickerCtl.Sprint

export const ApplyCustomStickerPopup = observer(() => {
  const [state, store] = useMultiActionsWithTasksStore()
  if (!state.tag) {
    return null
  }
  if (!state.applyCustomStickerPopup) {
    return null
  }
  const type = Sticker.getType(state.tag)
  return (
    <Popup
      title={Lang.msg.multiActionsWithTasks.applyCustomStickerState(
        state.stickerName,
        type === 'string'
          ? stringCtl.getState(state.tag, state.stickerState)?.name
          : sprintCtl.getState(state.tag, state.stickerState)?.name,
        state.tasksIds.size
      )}
      width={460}
      autoHeight
      minHeightAuto
      noPropagateOverlay
      noPropagateBody
      close={() => store.setApplyCustomStickerPopup(false)}
      contentClassName="h-full items-end flex pb-16"
    >
      <div className="flex gap-8">
        <Button onClick={() => store.stickerTurnOff()}>
          {Lang.msg.multiActionsWithTasks.yesConfirm}
        </Button>
        <TwCancelButton
          onClick={e => {
            noPropagate(e)
            store.setApplyCustomStickerPopup(false)
          }}
        >
          {Lang.msg.multiActionsWithTasks.cancel}
        </TwCancelButton>
      </div>
    </Popup>
  )
})
